<div class="row">
    <div class="col-12 col-xl-10 content-area">
        <h2>{{ 'Standard.Templates' | translate }}</h2>
        <p>{{ 'TemplateManager.ManageTemplatesSubText' | translate }}.</p>
    </div>

    <!-- Rules old -->
    <div class="col-12 col-xl-10 content-area" *ngIf="oldRules">
        <h3>{{ 'Standard.TaskLibrary' | translate }}</h3>
        <div class="newItem">
            <div class="d-flex justify-content-start mb-2 mt-2" *ngIf="ruleState == 'new'">
                <button class="btn btn-primary" (click)="ruleState = 'category'">{{ 'Word.New' | translate }} {{ 'Standard.Category' | translate | translate }}</button>
                <button class="btn btn-primary ml-3" (click)="ruleState = 'account'">{{ 'Word.New' | translate }} {{ 'Standard.Account' | translate | lowercase }}</button>
            </div>
            <!-- New Category -->
            <div class="emulated-flex-gap mb-2" *ngIf="ruleState == 'category'">
                <div class="form-group">
                    <label for="newAccountTitle">{{ 'Standard.Name' | translate }}</label>
                    <input type="text" class="form-control" id="newAccountTitle" [(ngModel)]="opsMaintenenceCategories.new.name">
                </div>
                <div class="form-group">
                    <label for="exampleFormControlSelect1">{{ 'Categories.BelongsTo' | translate }}</label>
                    <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="opsMaintenenceCategories.new.parentId">
                        <option [value]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                        <option *ngFor="let x of opsMaintenenceCategories.tree" [value]="x.id">{{ x.name }}</option>
                    </select>
                </div>
                <button type="submit" class="btn btn-primary mb-0 mt-auto" (click)="addDVCategory()" [disabled]="!opsMaintenenceCategories.new.name">{{ 'Buttons.Create' | translate }}</button>
                <button type="submit" class="btn btn-danger mb-0 mt-auto ml-3" (click)="ruleState = 'new'">{{ 'Buttons.Undo' | translate }}</button>
            </div>
            <!-- New Account -->
            <div class="emulated-flex-gap mb-2" *ngIf="ruleState == 'account'">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">{{ 'Standard.Category' | translate }}</label>
                    <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="opsMaintenenceCategories.newItem.data.categoryId">
                        <option [value]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                        <option *ngFor="let x of opsMaintenenceCategories.tree" [value]="x.id">{{ x.name }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="newAccountTitle">{{ 'Standard.Title' | translate }}</label>
                    <input type="text" class="form-control" id="newAccountTitle" [(ngModel)]="opsMaintenenceCategories.newItem.data.title">
                </div>
                <div class="form-group">
                    <label for="newAccountText">{{ 'Standard.Description' | translate }}</label>
                    <input type="text" class="form-control" id="newAccountText" [(ngModel)]="opsMaintenenceCategories.newItem.data.text">
                </div>
                <div class="form-group number-grp">
                    <label for="newAccountPropertyCost">{{ 'Standard.Account' | translate }} 1</label>
                    <input type="text" class="form-control" id="newAccountPropertyCost" [(ngModel)]="opsMaintenenceCategories.newItem.data.propertyCost">
                </div>
                <div class="form-group number-grp">
                    <label for="newAccountSubscription">{{ 'Standard.Account' | translate }} 2</label>
                    <input type="text" class="form-control" id="newAccountSubscription" [(ngModel)]="opsMaintenenceCategories.newItem.data.subscription">
                </div>
                <div class="form-group number-grp">
                    <label for="newAccountCommonCost">{{ 'Standard.Account' | translate }} 3</label>
                    <input type="text" class="form-control" id="newAccountCommonCost" [(ngModel)]="opsMaintenenceCategories.newItem.data.commonCost">
                </div>
                <button type="submit" class="btn btn-primary mb-0 mt-auto" (click)="createDVItem()"
                    [disabled]="!opsMaintenenceCategories.newItem.data.categoryId || !opsMaintenenceCategories.newItem.data.title || !opsMaintenenceCategories.newItem.data.text">{{ 'Buttons.Create' | translate }}</button>
                <button type="submit" class="btn btn-danger mb-0 mt-auto ml-3" (click)="ruleState = 'new'">{{ 'Buttons.Undo' | translate }}</button>
            </div>
        </div>

        <div>
            <div class="ml-3" id="test" *ngIf="opsMaintenenceCategories.tree">
                <app-ops-and-maintain-tree [elementId]="'test'" [data]="opsMaintenenceCategories.tree" [search]="opsMaintenenceCategories.search" [selectable]="false" [editable]="true"
                    (bubble)="dvChildEvent($event)"></app-ops-and-maintain-tree>
            </div>
        </div>

    </div>
    <!-- Rules new -->
    <div class="col-12 col-xl-10 content-area" *ngIf="!oldRules">
        <h3>{{ 'Standard.TaskLibrary' | translate }}</h3>
        <div class="row">
            <div class="col-12">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item cursor-pointer" (click)="rulesTab = 'list'; ruleListState = 'new'; ruleState = 'new'">
                        <a class="nav-link" id="pills-list-tab" role="tab" [ngClass]="rulesTab == 'list' ? 'active' : ''">{{ 'TemplateManager.TaskList' | translate }}</a>
                    </li>
                    <li class="nav-item cursor-pointer" (click)="rulesTab = 'tasks'; ruleListState = 'new'; ruleState = 'new'">
                        <a class="nav-link" id="pills-tasks-tab" role="tab" [ngClass]="rulesTab == 'tasks' ? 'active' : ''">{{ 'TemplateManager.Tasks' | translate }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row">
            <!-- TASKS -->
            <div class="col-12" *ngIf="rulesTab == 'tasks'">
                <div class="d-flex justify-content-start mt-2" *ngIf="ruleState == 'new'">
                    <button class="btn btn-primary" (click)="ruleState = 'rule'">{{ 'TemplateManager.NewTask' | translate }}</button>
                </div>
                <!-- New Rule -->
                <div class="emulated-flex-gap mb-2 mt-2" *ngIf="ruleState == 'rule'">
                    <div class="form-group">
                        <label for="newRuleSubject">{{ 'Standard.Title' | translate }}</label>
                        <input type="text" class="form-control" id="newRuleSubject" [(ngModel)]="data.newRule.subject">
                    </div>
                    <div class="form-group">
                        <label for="newRuleName">{{ 'Standard.Name' | translate }}</label>
                        <input type="text" class="form-control" id="newRuleName" [(ngModel)]="data.newRule.name">
                    </div>
                    <div class="form-group">
                        <label for="newRuleDescription">{{ 'Standard.Description' | translate }}</label>
                        <input type="text" class="form-control" id="newRuleDescription" [(ngModel)]="data.newRule.description">
                    </div>
                    <div class="form-group custom-form">
                        <label for="newDurationInMinutes">{{ 'Activity.Duration' | translate }} {{ 'Standard.Subtexts.Hours' | translate }}</label>
                        <input type="number" class="form-control" id="newDurationInMinutes" [(ngModel)]="data.newRule.durationInMinutes" placeholder="{{ 'Standard.NothingSpecified' | translate }}">
                    </div>
                    <div class="form-group">
                        <label for="newRuleNumberOfDays">{{ 'Standard.NumberOfDays' | translate }}</label>
                        <input type="number" class="form-control" id="newRuleNumberOfDays" [(ngModel)]="data.newRule.numberOfDays">
                    </div>
                    <div class="form-group custom-form">
                        <label for="newRecurrance">{{ 'Recurrance.AddRecurrance' | translate }}</label>
                        <app-recurrance-calculator class="form-control-custom" id="newRecurrance" [(rule)]="data.newRule.recurrance" [options]="{hideResult: true, areaBg: '#eeeeee', autoOpen: false}"></app-recurrance-calculator>
                    </div>
                    <div class="form-group">
                        <label for="newRuleActivityType">{{ 'Activities.ActivityType' | translate }}</label>
                        <select class="form-control" id="newRuleActivityType" [(ngModel)]="data.newRule.activityTypeId">
                            <option [value]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                            <option *ngFor="let x of activityTypes" [value]="x.id">{{ x.name }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="newRuleActivityType">{{ 'Standard.Priority' | translate }}</label>
                        <select class="form-control" id="newRuleActivityType" [(ngModel)]="data.newRule.priorityId">
                            <option [value]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                            <option *ngFor="let x of priorities" [value]="x.priorityId">{{ x.name }}</option>
                        </select>
                    </div>
                    <button type="submit" class="btn btn-primary mb-0 mt-auto" (click)="addRule()">{{ 'Buttons.Create' | translate }}</button>
                    <button type="submit" class="btn btn-outline-secondary mb-0 mt-auto ml-3" (click)="ruleState = 'new'">{{ 'Buttons.Undo' | translate }}</button>
                </div>
                <!-- Edit Rule -->
                <div class="emulated-flex-gap mb-2 mt-2" *ngIf="ruleState == 'editRule'">
                    <div class="form-group">
                        <label for="editRuleSubject">{{ 'Standard.Title' | translate }}</label>
                        <input type="text" class="form-control" id="editRuleSubject" [(ngModel)]="data.editRule.subject">
                    </div>
                    <div class="form-group">
                        <label for="editRuleName">{{ 'Standard.Name' | translate }}</label>
                        <input type="text" class="form-control" id="editRuleName" [(ngModel)]="data.editRule.name">
                    </div>
                    <div class="form-group">
                        <label for="editRuleDescription">{{ 'Standard.Description' | translate }}</label>
                        <input type="text" class="form-control" id="editRuleDescription" [(ngModel)]="data.editRule.description">
                    </div>
                    <div class="form-group custom-form">
                        <label for="editDurationInMinutes">{{ 'Activity.Duration' | translate }} {{ 'Standard.Subtexts.Hours' | translate }}</label>
                        <input type="number" class="form-control" id="editDurationInMinutes" [(ngModel)]="data.editRule.durationInMinutes" placeholder="{{ 'Standard.NothingSpecified' | translate }}">
                    </div>
                    <div class="form-group">
                        <label for="editRuleNumberOfDays">{{ 'Standard.NumberOfDays' | translate }}</label>
                        <input type="number" class="form-control" id="editRuleNumberOfDays" [(ngModel)]="data.editRule.numberOfDays">
                    </div>
                    <div class="form-group custom-form">
                        <label for="editRecurrance">{{ 'Recurrance.AddRecurrance' | translate }}</label>
                        <app-recurrance-calculator class="form-control-custom" id="editRecurrance" [(rule)]="data.editRule.recurrance"
                            [options]="{hideResult: true, areaBg: '#eeeeee', autoOpen: !!data.newRule.recurrance ? true : false}"></app-recurrance-calculator>
                    </div>
                    <div class="form-group">
                        <label for="editRuleActivityType">{{ 'Activities.ActivityType' | translate }}</label>
                        <select class="form-control" id="editRuleActivityType" [(ngModel)]="data.editRule.activityTypeId">
                            <option [value]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                            <option *ngFor="let x of activityTypes" [value]="x.id">{{ x.name }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="newRuleActivityType">{{ 'Standard.Priority' | translate }}</label>
                        <select class="form-control" id="newRuleActivityType" [(ngModel)]="data.editRule.priority.id">
                            <option [value]="null">{{ 'Standard.NoneChosen' | translate }}</option>
                            <option *ngFor="let x of priorities" [value]="x.priorityId">{{ x.name }}</option>
                        </select>
                    </div>
                    <button type="submit" class="btn btn-primary mb-0 mt-auto" (click)="updateRule()">{{ 'Buttons.Save' | translate }}</button>
                    <button type="submit" class="btn btn-outline-secondary mb-0 mt-auto ml-3" (click)="ruleState = 'new'">{{ 'Buttons.Undo' | translate }}</button>
                    <button type="submit" class="btn btn-outline-danger mb-0 mt-auto ml-3" (click)="deleteRule()"><span class="fa fa-trash"></span></button>
                </div>
                <!-- Rules -->
                <div *ngIf="!!data.rules">
                    <hr>
                    <div class="RuleItem">
                        <table aria-label="Rules items">
                            <thead>
                                <tr>
                                    <th>{{ 'Standard.Title' | translate }}</th>
                                    <th>{{ 'Standard.Name' | translate }}</th>
                                    <th>{{ 'Standard.Description' | translate }}</th>
                                    <th>{{ 'Standard.NumberOfDays' | translate }}</th>
                                    <th>{{ 'Standard.Activitytype' | translate }}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let x of data.rules; trackBy: trackById">
                                    <td class="ruleTitle ellipsis">{{ x.subject }}</td>
                                    <td class="ruleTitle ellipsis">{{ x.name }}</td>
                                    <td class="ruleDescription ellipsis">{{ x.description }}</td>
                                    <td draggable="true">{{ x.numberOfDays }}</td>
                                    <td class="ruleTitle ellipsis"><span *ngIf="!!x.activityTypeId && !!activityTypes"><span [attr.class]="findActivityType(x.activityTypeId, 'icon') + ' icon'"></span>{{ findActivityType(x.activityTypeId,
                                            'name') }}</span></td>
                                    <td (click)="editRule(x)"><span class="fa fa-pencil"></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- LIST -->
            <div class="col-12" *ngIf="rulesTab == 'list'">
                <div class="d-flex justify-content-start mb-2 mt-2" *ngIf="ruleListState == 'new'">
                    <button class="btn btn-primary" (click)="ruleListState = 'ruleList'">{{ 'TemplateManager.NewTaskList' | translate }}</button>
                </div>
                <!-- New Rule List -->
                <div class="emulated-flex-gap mb-2" *ngIf="ruleListState == 'ruleList'">
                    <div class="form-group">
                        <label for="newRuleName">{{ 'Standard.Name' | translate }}</label>
                        <input type="text" class="form-control" id="newRuleName" [(ngModel)]="data.newRuleList.name">
                    </div>
                    <button type="submit" class="btn btn-primary mb-0 mt-auto" (click)="addRuleList()">{{ 'Buttons.Create' | translate }}</button>
                    <button type="submit" class="btn btn-outline-secondary mb-0 mt-auto ml-3" (click)="ruleListState = 'new'">{{ 'Buttons.Undo' | translate }}</button>
                </div>
                <!-- Edit Rule List -->
                <div class="emulated-flex-gap mb-2" *ngIf="ruleListState == 'editList'">
                    <div class="form-group">
                        <label for="editRuleName">{{ 'Standard.Name' | translate }}</label>
                        <input type="text" class="form-control" id="editRuleName" [(ngModel)]="data.editRuleList.name">
                    </div>
                    <button type="submit" class="btn btn-primary mb-0 mt-auto" (click)="updateRuleList()">{{ 'Buttons.Save' | translate }}</button>
                    <button type="submit" class="btn btn-outline-secondary mb-0 mt-auto ml-3" (click)="ruleListState = 'new'">{{ 'Buttons.Undo' | translate }}</button>
                </div>
                <!-- Rules In List -->
                <div *ngIf="!!data.ruleLists">
                    <div class="ruleListItem" *ngFor="let r of data.ruleLists; trackBy: trackById" [attr.id]="r.id">
                        <div class="ruleListItemContent">
                            <div class="ruleListNameBadge cursor-pointer" (click)="showRulesList(r.id)">
                                <span class="mr-3">
                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="hero-icon-small" *ngIf="data.showRulesInList == r.id">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M0.230169 0.209376C0.528748 -0.0777189 1.00353 -0.0684095 1.29063 0.230169L5 4.16792L8.70938 0.230169C8.99647 -0.0684094 9.47125 -0.0777189 9.76983 0.209376C10.0684 0.496471 10.0777 0.971254 9.79063 1.26983L5.54063 5.76983C5.39922 5.91689 5.20401 6 5 6C4.79599 6 4.60078 5.91689 4.45938 5.76983L0.209376 1.26983C-0.0777189 0.971254 -0.0684095 0.496471 0.230169 0.209376Z"
                                            fill="black" />
                                    </svg>
                                    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="hero-icon-small" *ngIf="data.showRulesInList != r.id">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M0.209376 9.76983C-0.0777189 9.47125 -0.0684094 8.99647 0.230169 8.70937L4.16792 5L0.230169 1.29062C-0.0684099 1.00353 -0.0777193 0.528747 0.209376 0.230167C0.496471 -0.0684109 0.971253 -0.0777207 1.26983 0.209374L5.76983 4.45937C5.91689 4.60078 6 4.79599 6 5C6 5.20401 5.91689 5.39922 5.76983 5.54062L1.26983 9.79062C0.971254 10.0777 0.496471 10.0684 0.209376 9.76983Z"
                                            fill="black" />
                                    </svg>
                                </span>
                                <span class="badge badge-primary mr-3">{{ r.rules.length }}</span>
                                <span class="text-bold">{{ r.name }}</span>
                            </div>
                            <div (click)="removeRuleList(r.id)" *ngIf="r.rules.length == 0">
                                <span class="fa fa-trash text-danger"></span>
                            </div>
                            <div (click)="editRuleListItem(r)" *ngIf="r.rules.length > 0">
                                <span class="fa fa-pencil"></span>
                            </div>
                        </div>
                        <div class="ruleListRules" *ngIf="data.showRulesInList == r.id">
                            <div *ngIf="r.rules.length > 0">
                                <rule-list [rule]="x" [listId]="r.id" (ruleRemoved)="onRemoveRuleFromList($event)" *ngFor="let x of r.rules"></rule-list>
                            </div>
                            <button type="button" class="btn btn-primary addtasksBtn" data-toggle="modal" data-target="#addRulesToListModal" (click)="selectRule()">{{ 'TemplateManager.AddTasksToList' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Add rules to list -->
<div class="modal fade" id="addRulesToListModal" tabindex="-1" role="dialog" aria-labelledby="addRulesToListModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addRulesToListModalLabel">{{ 'TemplateManager.AddTasksToList' | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="addRulesToListModalCloseBtn"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <div class="RuleItem">
                    <table *ngIf="!!data.rules" aria-label="Rules list">
                        <thead>
                            <tr>
                                <th>{{ 'Standard.Title' | translate }}</th>
                                <th>{{ 'Standard.Name' | translate }}</th>
                                <th>{{ 'Standard.Description' | translate }}</th>
                                <th>{{ 'Standard.Activitytype' | translate }}</th>
                                <th class="text-right">{{ 'Standard.NumberOfDays' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let x of data.rules; trackBy: trackById">
                                <td>
                                    <div class="custom-control custom-checkbox cursor-pointer">
                                        <input type="checkbox" class="custom-control-input" [attr.id]="x.id" [checked]="checkInList(x.id)" (click)="addRuleToSelection(x)">
                                        <label class="custom-control-label" [attr.for]="x.id">{{ x.subject }}</label>
                                    </div>
                                </td>
                                <td class="ruleTitle ellipsis cursor-default">{{ x.name }}</td>
                                <td class="ruleDescription ellipsis cursor-default">{{ x.description }}</td>
                                <td class="ruleTitle ellipsis cursor-default"><span *ngIf="!!x.activityTypeId && !!activityTypes"><span [attr.class]="findActivityType(x.activityTypeId, 'icon') + ' icon'"></span>{{
                                        findActivityType(x.activityTypeId, 'name') }}</span></td>
                                <td class="cursor-default text-right">{{ x.numberOfDays }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
                <button type="button" class="btn btn-primary" (click)="saveRulesToList()">{{ 'Buttons.Save' | translate }}</button>
            </div>
        </div>
    </div>
</div>